// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__158_m","noImage":"Hero_noImage__1MqwA","title":"Hero_title__12dC2","author":"Hero_author__su0IX","lead":"Hero_lead__3MFDh","image":"Hero_image__22lZD"};